/*
 * pod.link designer.
 */
import Designer from './Designer';

export default Designer;
